import { actions as notificationActions } from '@saucelabs/sl-container-notifications';

import * as actions from './actions';

export const connectMobileDevice = (payload) => (dispatch) => (
  dispatch(actions.connectMobileDevice(payload))
    .catch((error) => {
      dispatch(notificationActions.notifyDanger(error));
    })
);

export const disconnectMobileDevice = () => (dispatch, getState) => {
  const device = getState().apps.job.rdcPreviewSession.get('device');

  if (device) {
    device.close();
  }

  dispatch(actions.disconnectMobileDevice());
};
